import React, { useState } from 'react';
import II18 from '../translate/II18';
import {
  Block,
  Button,
  List,
  ListInput,
  ListItemRow,
  f7,
  Checkbox
} from 'framework7-react';
import PaperflyAPI from '../../server/api/PaperflyAPI';
import PropTypes from 'prop-types';
import { emailIsValid, phoneIsValid } from '../helpers/utils';

export default function CustomFormMerkur(props) {
  const [userEmail, setUserEmail] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [agree, setAgree] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const emailValid = emailIsValid(userEmail);
  const phoneValid = phoneIsValid(userPhone);

  const emailNotValid = userEmail && !emailValid;
  const phoneNotValid = userPhone && !phoneValid;

  const userDataOk =
    !(emailNotValid || phoneNotValid) && (userEmail || userPhone) && agree;

  const onClick = () => {
    PaperflyAPI.merkurRegisterEmail(
      props.recipientRequestId,
      userEmail,
      userPhone
    ).then(
      () => setEmailSent(true),
      error => f7.dialog.alert(II18.get('technical_error'))
    );
  };

  return (
    <div
      style={{
        paddingBottom: window.isDesktop ? 45 : 35,
        paddingTop: 10
      }}
    >
      {emailSent ? (
        <Block>
          <p
            className={'tracking-in-expand'}
            style={{
              padding: '0 10px',
              textAlign: 'center',
              color: '#4cd964',
              fontSize: 16,
              fontWeight: 'bold',
              paddingTop: 40
            }}
          >
            {II18.get('title_successfull_sent')}
          </p>
        </Block>
      ) : (
        <div>
          <List
            noHairlines
            noHairlinesBetween
            style={{ width: '100%', margin: '10px 0' }}
          >
            <ListItemRow>
              <label
                style={{
                  textAlign: 'left',
                  display: 'block',
                  width: window.isDesktop ? '90%' : '100%',
                  padding: '0 10px',
                  fontWeight: 'bold',
                  fontSize: 16,
                  margin: '0 auto'
                }}
              >
                {II18.get('merkur_message_1')}
              </label>
            </ListItemRow>
            <ListItemRow>
              <label
                style={{
                  textAlign: 'left',
                  display: 'block',
                  width: window.isDesktop ? '90%' : '100%',
                  padding: '0 10px',
                  fontSize: 14,
                  margin: '0 auto',
                  paddingBottom: 10
                }}
              >
                {II18.get('merkur_message_2')}
              </label>
            </ListItemRow>
            <ListInput
              id={'userEmail'}
              onInputClear={() => setUserEmail('')}
              outline
              floatingLabel
              errorMessageForce={emailNotValid}
              errorMessage={II18.get('post_request_wrong_email_only')}
              required
              label={II18.get('post_request_your_email_only_message')}
              type="text"
              clearButton
              value={userEmail || ''}
              onChange={e => setUserEmail(e.target.value.trim())}
              style={{
                marginBottom: -10
              }}
            />
            <ListInput
              id={'userPhone'}
              onInputClear={() => setUserPhone('')}
              outline
              floatingLabel
              errorMessageForce={phoneNotValid}
              errorMessage={II18.get('post_request_wrong_phone_only')}
              required
              label={II18.get('post_request_your_phone_only_message')}
              type="text"
              clearButton
              value={userPhone || ''}
              onChange={e => setUserPhone(e.target.value.trim())}
              style={{
                marginBottom: 5
              }}
            />
            <ListItemRow>
              <label
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  width: '100%',
                  margin: '0 auto',
                  maxWidth: 485,
                  paddingLeft: 15
                }}
              >
                <Checkbox
                  style={{ marginTop: 3 }}
                  name="privacy"
                  checked={agree}
                  onChange={() => setAgree(!agree)}
                />
                <label
                  style={{
                    marginLeft: 10,
                    fontSize: window.isDesktop ? 16 : 14
                  }}
                >
                  {II18.get('merkur_sendout_agree')}
                </label>
              </label>
            </ListItemRow>
          </List>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              marginTop: 30
            }}
          >
            <Button
              id={'sendDocumentsAndUserDataButton'}
              className={userDataOk ? 'active' : 'notactive'}
              popupClose
              color={userDataOk ? 'green' : 'gray'}
              raised
              fill
              disabled={!userDataOk}
              style={{
                maxWidth: 350,
                lineHeight: '48px',
                height: 48,
                fontSize: 16,
                padding: '0 30px',
                marginBottom: 20,
                color: userDataOk ? 'white' : '#cfcfcf',
                backgroundColor: userDataOk ? 'green' : '#eae9e9',
                boxShadow: userDataOk ? {} : 'none'
              }}
              onClick={onClick}
            >
              <span>{II18.get('title_sendout')}</span>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

CustomFormMerkur.propTypes = {
  recipientRequestId: PropTypes.string
};
